<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import Multiselect from "vue-multiselect";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "This Month's Salaries",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Multiselect
  },
  data() {
    return {
      title: "This Month's Salaries",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "This Month's Salaries",
          active: true,
        },
      ],
      totalRows: 1,
      serverPerPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "staff_name",
          sortable: true,
          label: "STAFF",
        },
        {
          key: "month_year",
          sortable: true,
          label: "MONTH-YEAR",
        },
        {
          key: "net_pay",
          sortable: true,
          label: "NET SALARY",
        },
        {
          key: "total_paid",
          sortable: true,
          label: "TOTAL PAID",
        },
        {
          key: "total_advances",
          sortable: true,
          label: "TOTAL ADVANCES",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
      ],
      staffError: "",
      amountError: "",
      modeError: "",
      dateError: "",
      monthError: "",

      // Value from user input for adding unit
      data: {
        type: 1,
        staff: "",
        month_year: moment(new Date()).format("YYYY-MM"),
        amount_paid: "",
        mode: "",
        date: "",
      },
      IsMonthlyStaffSalariesServerPaginated: true,
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("staff", [
      "StaffSave",
      "Staff",
      "MonthlyStaffSalaries",
      "MonthlyStaffSalariesPagination",
      "MonthlyStaffSalariesPaginated",
      "filterStatus",
    ]),
    ...mapGetters("auth", ["MyUserPerm", "branchid"]),
    ...mapGetters("setting", ["PaymentOptions"]),

    rows() {
      return this.IsMonthlyStaffSalariesServerPaginated
        ? (this.MonthlyStaffSalariesPagination &&
            this.MonthlyStaffSalariesPagination.total) ||
            0
        : this.MonthlyStaffSalaries
        ? this.MonthlyStaffSalaries.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsMonthlyStaffSalariesServerPaginated) {
          return (
            (this.MonthlyStaffSalariesPagination &&
              this.MonthlyStaffSalariesPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsMonthlyStaffSalariesServerPaginated) {
          this.data.per_page = value;
          this.fetchMonthlySalaryStatement();
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.IsMonthlyStaffSalariesServerPaginated &&
          this.MonthlyStaffSalariesPagination
          ? this.MonthlyStaffSalariesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.IsMonthlyStaffSalariesServerPaginated) {
          this.data.page = value;
          this.fetchMonthlySalaryStatement();
        }
      },
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.MonthlyStaffSalaries
      ? this.MonthlyStaffSalaries.length
      : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetAdd();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStaff: "staff/fetchAllStaff",
      AddStaffSalaries: "staff/addStaffSalary",
      FetchMonthlyStaffSalaries: "staff/fetchMonthlyStaffSalaries",
      FetchModes: "setting/fetchPaymentOptions",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addStaffSalaries(modalId) {
      this.modal_id = modalId;

      if (this.data.staff === "") {
        this.staffError = "Staff field is required";
      } else if (this.data.amount_paid === "" && this.data.type === 2) {
        this.amountError = "Amount Paid field is required";
        return;
      } else if (this.data.mode === "") {
        this.modeError = "Payment mode field is required";
        return;
      } else if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else if (this.data.month_year === "") {
        this.dateError = "Month field is required";
        return;
      }

      this.AddStaffSalaries(this.data);
    },

    resetAdd() {
      this.data.staff = "";
      this.data.amount_paid = "";
      this.data.date = "";
      this.data.mode = "";
      this.data.month_year = "";
      this.modal_id = "";
    },
    resetError() {
      this.staffError = "";
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.mobthError = "";
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount_paid = this.thousandSeprator(this.data.amount_paid);
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions.filter((mode) => {
        return mode.default == 1;
      });
      this.data.mode = defaultop[0].id;
    },
    ClearSatff() {
      this.data.staff = "";
    },

    buildFilterPayload() {
      const payload = {
        page: this.data.page || 1,
        per_page: this.data.per_page || this.serverPerPage || 10,
      };

      if (
        this.data.staff !== "" &&
        this.data.staff !== null &&
        this.data.staff !== undefined
      ) {
        payload.staff = this.data.staff;
        payload.staff_id = this.data.staff;
      }

      return payload;
    },

    fetchMonthlySalaryStatement() {
      const payload = this.buildFilterPayload();
      this.FetchMonthlyStaffSalaries(payload);
    },

    filterReport() {
      this.data.page = 1;
      this.fetchMonthlySalaryStatement();
    },
  },
  created() {
    this.FetchStaff();
    this.fetchMonthlySalaryStatement();
    this.FetchModes();
    setTimeout(() => {
      this.setDefaultMode();
    }, 3000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title">This Month's Salaries</h4>
              </div>
              <div class="col-md-3" align="right">
                <b-button @click="$router.go(-1)" variant="warning"
                  ><i class="fa fa-arrow-left"></i> Back</b-button
                >
              </div>
              <div
                v-if="MyUserPerm.add_staff_salaries == 1 && branchid != 0"
                class="col-md-3"
                align="right"
              >
                <b-button v-b-modal.add_salary-modal variant="primary"
                  >New Payment</b-button
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Filter by Staff</label>
                <model-list-select
                  :list="Staff ? [{ id: '', name: 'All Staff' }, ...Staff] : []"
                  v-model="data.staff"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Staff"
                  @input="filterReport()"
                />
              </div>
              <div class="col-md-2 mt-2 d-flex align-items-end">
                <button class="btn btn-primary" @click="filterReport">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="MonthlyStaffSalaries?MonthlyStaffSalaries:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- add modal starts -->
    <b-modal
      id="add_salary-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template #modal-title> Add Salary Payment</template>

      <div class="row">
        <div class="form-group mb-3">
          <label
            >Payment type (<em class="text-info"
              >multiple payments or one payment</em
            >)</label
          >
          <div class="input-group">
            <select
              v-model="data.type"
              class="form-control"
              @change="ClearSatff()"
            >
              <option value="1">Multiple Payments</option>
              <option value="2">One Payment</option>
            </select>
          </div>
        </div>

        <div class="form-group mb-3" v-if="data.type == 1">
          <label>Staff members paid</label>
          <div class="input-group">
            <multiselect
              v-model="data.staff"
              :options="Staff"
              :multiple="true"
              :track-by="'id'"
              label="name"
              placeholder="Select staff"
            >
            </multiselect>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>

        <div class="form-group mb-3" v-if="data.type == 2">
          <label>Staff</label>
          <div class="input-group">
            <model-list-select
              :list="Staff ? Staff : []"
              v-model="data.staff"
              option-value="id"
              option-text="name"
              placeholder="Select staff"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>

        <div class="form-group mb-3" v-if="data.type == 2">
          <label>Amount Disbursed</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount Paid"
              class="form-control"
              v-model="data.amount_paid"
              @input="addCommas(), resetError()"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Month-Year</label>
          <div class="input-group">
            <input
              type="month"
              class="form-control"
              v-model="data.month_year"
              @input="resetError()"
            />
            <div class="text-danger" v-if="monthError">
              <em>{{ monthError }}</em>
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Disbursed on</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              v-model="data.date"
              @input="resetError()"
            />
            <div class="text-danger" v-if="dateError">
              <em>{{ dateError }}</em>
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Payment Method</label>
          <model-list-select
            :list="PaymentOptions ? PaymentOptions : []"
            v-model="data.mode"
            option-value="id"
            option-text="mode"
            placeholder="Select Method"
            @input="resetError()"
          >
          </model-list-select>
          <div class="text-danger" v-if="modeError">
            <em>{{ modeError }}</em>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add_salary-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addStaffSalaries('add_salary-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="StaffSave"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
</style>
